import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import { AuthContext } from "../../components/auth/AuthContext";
import { AppDataContext } from "../../components/context/app-data-context";
import { getPageInfo } from "../../helpers";
import Utils from "../../utils";
import CustomHeader from "./header";

function AppHeaderBar({ setIsAdmin, handleDrawerToggle }) {
    const location = useLocation();
    const { currentNonAdminGroup, isAuthenticated, isAdmin, user } = React.useContext(AuthContext);
    const { setCurrentCompanyAlerts, loadCompanyAlertsData, clearAppData } = React.useContext(AppDataContext);

    const [userFullName, setUserFullName] = React.useState("");
    const pageInfo = getPageInfo(location.pathname);

    useEffect(() => {
        async function getCompanyData() {
            setIsAdmin(isAdmin);
            try {
                if (!isAuthenticated) {
                    setCurrentCompanyAlerts([]);
                    setIsAdmin(false);
                    clearAppData();
                    return;
                }

                // load company alerts data
                loadCompanyAlertsData();
                
                // Check if user groups include "admin"
                if (!isAdmin) {
                    return; // Exit if not an admin
                }
            } catch (e) {
                console.log(e);
            }
        }
        getCompanyData();
    }, [currentNonAdminGroup, isAdmin, isAuthenticated]);

    useEffect(() => {
        if (user?.username && isAuthenticated) {
            const getUser = async () => {
                const userData = (await Utils.genericGet("getUser", user.username)).data.getUser;

                // when user is registering him self from signup, we got user data = null
                // So we have to create the user in user table
                // It will fix the profile update error fix
                if(userData === null) {
                    await Utils.genericMutation("createUser", {
                        id: user.username
                    });
                }
                if (userData?.firstname && userData?.lastname) {
                    setUserFullName(userData.firstname + " " + userData.lastname);
                }
            }
            getUser();
        }
    }, [user, isAuthenticated])

    return (
        <AppBar className={pageInfo?.title}
            position="sticky"
            sx={{
                background: "transparent",
                height: 80,
                boxShadow: "none",
                zIndex: "999",
            }}
        >
            <CustomHeader
                user={user}
                userFullName={userFullName}
                handleDrawerToggle={handleDrawerToggle}
            />
        </AppBar>
    );
}

export default AppHeaderBar;